import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [Region.IMP, Region.MINERVA, Region.CDI],
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const can_access_receiving_pump_off = new MockSplit({
    name: 'can_access_receiving_pump_off',
    environments: [local, dev, staging, demo, prod],
});

export default can_access_receiving_pump_off;
